import { Origin } from "../../../../../models";
import { PublicDevelopmentManagerDetailsPreviewTemplate } from "../../../../../templates";
import { getDevelopmentManagerSettingsMarketingAssetsRoute } from "../../../../../utils/routes";
import { PreviewBanner } from "../../../../../widget";
import { usePreview } from "./usePreview";

const Preview = (): JSX.Element => {
  const { dataIsLoading, previewUuid, previewData, navigate } = usePreview();

  return (
    <>
      <PreviewBanner
        description="You are currently viewing a preview version of the page. These changes will not be published until you close the preview and save your changes"
        onClose={() => {
          navigate(
            getDevelopmentManagerSettingsMarketingAssetsRoute(
              {
                origin: Origin.DevelopmentManagerDetailsPreview,
              },
              previewUuid
            )
          );
        }}
      />
      {!dataIsLoading && previewData && <PublicDevelopmentManagerDetailsPreviewTemplate previewData={previewData} />}
    </>
  );
};

export default Preview;
